import { http } from '../../config/axios'

export default function postRepresentante(representante: any): Promise<string> {
  return http
    .post('api/representante', representante)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post representante', error)
      throw Error(error.response.data)
    })
}
